<router-outlet></router-outlet>

<div kendoDialogContainer></div>

<div
  class="loader-block overlay"
  *ngIf="isLoading$ | async"
>
  <app-loader></app-loader>
</div>
